import { Observable } from 'rxjs/Observable';
import { OnInit, AfterViewChecked, Component } from '@angular/core';
import { Usuario } from '../../../models/usuario';
import { Perfis } from '../../../models/perfis';
import { StatusCandidato } from '../../../models/statusCandidato';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { AuthService } from '../../admin/auth.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { CandidatoService } from '../../candidato/candidato.service';
import { FaseService } from '../../fase/fase.service';

import { ConfirmationService } from 'primeng/primeng';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';



declare var $: any;

@Component({
  templateUrl: './gerenciar-etapas.component.html'

})

export class GerenciarEtapasComponent extends WebPage implements OnInit, AfterViewChecked {
  formGerenciarStatusAluno: FormGroup;
  candidato;
  usuario: Usuario;
  display = false;
  idCandidato;
  perfis;

  candidatos;
  // candidatosUnificados;
  unidades;
  statusCandidatoList;
  statusCandidatoPodemSerAlteradosList;
  fases;
  opcaoInscricaoList = [{value:1,titulo:'Primeira Habilitação'},{value:2,titulo:'Adição Categoria A/B'},{value:3,titulo:'Mudança Categoria D/E'},{value:4,titulo:'Inclusão de EAR e Curso de MotoFrete'}];

  constructor(
    private authService: AuthService,
    private unidadeService: UnidadeService,
    private candidatoService: CandidatoService,
    private faseService: FaseService,
    private fb: FormBuilder,
    messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    super(messageService);

    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;

    this.formGerenciarStatusAluno = fb.group({
      idCandidato: [null],
      idStatusCandidato: [null, Validators.required],
      liberarVaga: [null],
      justificativa: [null, Validators.required],
      arquivo:[null]
    });
  }

  ngOnInit() {
    if (
      this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex
    ) {
      // Versão antiga getfullCanidatos
      // this.isLoading = true;
      // this.candidatoService.getAllFull()
      //   .finally(() => this.isLoading = false)
      //   .subscribe(
      //     candidatos => {
      //       // this.candidatos = candidatos;
      //       console.log(candidatos);
      //     },
      //     error => this.gerenciaErro(error)
      //   );
      // Fim Versão antiga getfullCanidatos
        this.isLoading = true;
        this.candidatoService.getAllFullQuery()
        .finally(() => this.isLoading = false)
        .subscribe(
          candidatos => {
            console.log(candidatos);
            this.candidatos = candidatos;
          },
          error => this.gerenciaErro(error)
        );

      this.isLoading = true;
      this.unidadeService.getUnidadesParticipantes()
        .finally(() => this.isLoading = false)
        .subscribe(
          unidades => {
            console.log(unidades);

            this.unidades = unidades;
          },
          error => this.gerenciaErro(error)
        );

    } else {
      // this.isLoading = true;
      // this.candidatoService.getByUnidade(this.usuario.IdUnidade)
      //   .finally(() => this.isLoading = false)
      //   .subscribe(
      //     candidatos => this.candidatos = candidatos,
      //     error => this.gerenciaErro(error)
      //   );

      this.isLoading = true;
        this.candidatoService.getByUnidadeQuery(this.usuario.IdUnidade)
          .finally(() => this.isLoading = false)
          .subscribe(
            candidatos => this.candidatos = candidatos,
            error => this.gerenciaErro(error)
          );

      this.isLoading = true;
      this.unidadeService.getUnidadeFull(this.usuario.IdUnidade)
        .finally(() => this.isLoading = false)
        .subscribe(
          unidade => this.unidades = new Array(unidade),
          error => this.gerenciaErro(error)
        );
    }

    this.isLoading = true;
    this.candidatoService.getStatusCandidato()
    .finally(() => this.isLoading = false)
    .subscribe(
      statusCandidatoList => this.statusCandidatoList = statusCandidatoList,
      error => this.gerenciaErro(error)
    );

    this.isLoading = true;
    this.faseService.getAll()
    .finally(() => this.isLoading = false)
    .subscribe(
      fases => {
        // console.log(fases);
        this.fases = fases;
      },
      error => this.gerenciaErro(error)
    );

  }

  abrir(idCandidato:any){
    this.formGerenciarStatusAluno.reset();
    this.candidatoService
        .getFull(idCandidato)
        .finally(() => (this.isLoading = false))
        .subscribe(
          candidato => {
            this.candidato = candidato;

            if (this.candidato != null) {
              this.formGerenciarStatusAluno.controls['idCandidato'].setValue(this.candidato.idCandidato);
            }
          },
          error => this.gerenciaErro(error)
        );


    this.candidatoService.getStatusCandidatoPodemSerAlterados()
    .finally(() => this.isLoading = false)
    .subscribe(
      statusCandidatoPodemSerAlteradosList => this.statusCandidatoPodemSerAlteradosList = statusCandidatoPodemSerAlteradosList,
      error => this.gerenciaErro(error)
    );

    this.display = true;
  }

  submitFormGerenciarStatusAluno() {
    //console.log("teste envio");
    if (!this.formGerenciarStatusAluno.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Campo obrigatório não preenchido!'
      });
      return;
    }

   /* if (this.formGerenciarStatusAluno.value.idStatusCandidato.toUpperCase() === !StatusCandidato.DesclassificadoPorOutroMotivo) {
      this.LiberarVaga.setValue(null);
    }*/

    this.confirmationService.confirm({
      message: 'Deseja mesmo alterar o status deste aluno?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
          this.candidatoService.alterarStatusCandidato(this.formGerenciarStatusAluno.value)
          .subscribe(candidato => {
            console.log(candidato);

            this.candidato = null;
            this.formGerenciarStatusAluno.reset();
          },
          error => this.gerenciaErro(error));
      }
    });
}

podeMostrarAvisoTermoAdesaoExpirado(idStatusCandidato){
  idStatusCandidato = idStatusCandidato.toUpperCase();
  if(
     (idStatusCandidato === StatusCandidato.Aderido
      || idStatusCandidato === StatusCandidato.AprovadoCursoPratico
      || idStatusCandidato === StatusCandidato.AprovadoProvaPratica
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoCursoPratico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoExameToxicologico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoProvaPratica
      || idStatusCandidato === StatusCandidato.AprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros
      || idStatusCandidato === StatusCandidato.ClassificadoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.ClassificadoExameToxicologico
      || idStatusCandidato === StatusCandidato.ReprovadoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.ReprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros
      || idStatusCandidato === StatusCandidato.ReprovadoCursoPraticaDirecaoSimulada
      || idStatusCandidato === StatusCandidato.ReprovadoProvaPratica
      || idStatusCandidato === StatusCandidato.ReprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros
      || idStatusCandidato === StatusCandidato.AprovadoCursoPraticaDirecaoSimulada
      || idStatusCandidato === StatusCandidato.ReprovadoCursoPraticaDirecaoSimulada

    )
  ){
    return true;
  }else{
    return false;
  }
}

podeMostrarAvisoTermoAditivoExpirado(idStatusCandidato){
  idStatusCandidato = idStatusCandidato.toUpperCase();
  if(
     (idStatusCandidato === StatusCandidato.Aderido
      || idStatusCandidato === StatusCandidato.AprovadoCursoPratico
      || idStatusCandidato === StatusCandidato.AprovadoProvaPratica
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoCursoPratico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoExameToxicologico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoProvaPratica
      || idStatusCandidato === StatusCandidato.AprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros
      || idStatusCandidato === StatusCandidato.ClassificadoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.ClassificadoExameToxicologico
      || idStatusCandidato === StatusCandidato.ReprovadoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.ReprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros
      || idStatusCandidato === StatusCandidato.ReprovadoCursoPraticaDirecaoSimulada
      || idStatusCandidato === StatusCandidato.ReprovadoProvaPratica
      || idStatusCandidato === StatusCandidato.ReprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros
      || idStatusCandidato === StatusCandidato.AprovadoCursoPraticaDirecaoSimulada
      || idStatusCandidato === StatusCandidato.ReprovadoCursoPraticaDirecaoSimulada

    )
  ){
    return true;
  }else{
    return false;
  }

}

  podeMostrarReagendar(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();

    if (
      (
        this.usuario.Perfil === Perfis.AdministradorSistema
        || this.usuario.Perfil === Perfis.AdministrativoDex
        || this.usuario.Perfil === Perfis.GestorDex
      ) && (
        idStatusCandidato === StatusCandidato.Convocado
        || idStatusCandidato === StatusCandidato.ConvocadoPrazoExtra
        || idStatusCandidato === StatusCandidato.Reagendado
        || idStatusCandidato === StatusCandidato.DesclassificadoNaoComparecimento
        || idStatusCandidato === StatusCandidato.DesclassificadoPelaUnidade
      )
    ) {
      return true;
    }

    if (
      (
        this.usuario.Perfil === Perfis.GestorUnidadeOperacional
        || this.usuario.Perfil === Perfis.AdministrativoUnidadeOperacional
      ) && (
        idStatusCandidato === StatusCandidato.Convocado
        || idStatusCandidato === StatusCandidato.ConvocadoPrazoExtra
        || idStatusCandidato === StatusCandidato.Reagendado
      )
    ) {
      return true;
    }

    return false;
  }

  podeMostrarEditar(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();

    if (this.usuario.Perfil === Perfis.Financeiro
        || this.usuario.Perfil === Perfis.GestorUnidadeOperacional
        || this.usuario.Perfil === Perfis.AdministrativoUnidadeOperacional) {

        return idStatusCandidato === StatusCandidato.Inscrito
        || idStatusCandidato === StatusCandidato.Convocado
        || idStatusCandidato === StatusCandidato.ConvocadoPrazoExtra
        || idStatusCandidato === StatusCandidato.Reagendado;
      }else {
        return true;
      }
  }

  podeMostrarDocumentacao(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.Convocado
      || idStatusCandidato === StatusCandidato.ConvocadoPrazoExtra
      || idStatusCandidato === StatusCandidato.Reagendado;
  }

  podeMostrarExameToxicologico(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.Aderido
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoExameToxicologico;
  }

  podeMostrarExameMedicoPsicologico(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.ClassificadoExameToxicologico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.ReprovadoExameMedicoPsicologico;
  }

  podeMostrarCursoPratico(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.ClassificadoExameMedicoPsicologico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoCursoPratico
      || idStatusCandidato === StatusCandidato.ReprovadoCursoPratico;
  }

  podeMostrarProvaPratica(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.AprovadoCursoPratico
      || idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoProvaPratica
      || idStatusCandidato === StatusCandidato.ReprovadoProvaPratica;
  }

  podeMostrarCursoEspecializado(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.AprovadoProvaPratica
      || idStatusCandidato === StatusCandidato.AprovadoCursoEspecializadoCondutoresTransporteColetivoPassageiros
      || idStatusCandidato === StatusCandidato.AprovadoCursoPraticaDirecaoSimulada;
  }

  podeMostrarBotaoConcluirProcesso(idStatusCandidato: string) {
    idStatusCandidato = idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.AprovadoCursoPraticaDirecaoSimulada;
  }

  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  verificarPermissaoEditarCanidato() {
    if (
      this.usuario.Perfil === Perfis.AdministradorSistema
      || this.usuario.Perfil === Perfis.GestorDex
      || this.usuario.Perfil === Perfis.AdministrativoDex
    ) {
      return true;
    }
    return false;

  }

  gerarTermoAditivo(candidato:any){
    this.confirmationService.confirm({
      message: 'Deseja gerar o termo aditivo para este candidato?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.candidatoService.gerarTermoAditivo(candidato.idCandidato)
        this.messageService.add({
          severity: 'success',
          summary: 'Atenção',
          detail: 'Termo Aditivo Gerado com sucesso!'
        });
      }
    });
  }

  podeMostrarBotaoGerarTermo(candidato){

  }

  concluirProcesso(candidato:any){
    this.confirmationService.confirm({
      message: 'Deseja declarar o processo deste candidato como concluído?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {


        this.candidatoService.concluirProcesso(candidato.idCandidato)
          .subscribe(res => {

            candidato.idStatusCandidato =  StatusCandidato.Concluido;

            this.messageService.add({
              severity: 'success',
              summary: 'Atenção',
              detail: 'O processo foi concluído com sucesso'
            });
          },
          error => this.gerenciaErro(error));

      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/etapa/gerenciar-etapas/gerenciar-etapas.component.ts